import { GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__ } from '~/locale';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import getCatalogResourceComponentNames from '../../../graphql/queries/get_resource_component_names.query.graphql';
export default {
    name: 'ComponentNameToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            components: [],
            searchTerm: ''
        };
    },
    apollo: {
        components: {
            query: getCatalogResourceComponentNames,
            variables () {
                return {
                    fullPath: this.config.resourcePath
                };
            },
            update (data) {
                const nodes = data?.ciCatalogResource?.versions?.nodes?.[0]?.components?.nodes || [];
                return nodes.map((c)=>({
                        value: c.name,
                        text: c.name
                    }));
            },
            error () {
                createAlert({
                    message: s__('CiCatalog|There was an error fetching components.')
                });
            }
        }
    },
    computed: {
        loading () {
            return this.$apollo.queries.components.loading;
        },
        filteredComponents () {
            if (!this.searchTerm) return this.components;
            const term = this.searchTerm.toLowerCase();
            return this.components.filter((c)=>c.value.toLowerCase().includes(term));
        }
    },
    methods: {
        getActiveTokenValue (suggestions, data) {
            return suggestions.find((s)=>s.value === data);
        }
    }
};
